import React from 'react';
import { ListItem, Checkbox } from '@material-ui/core';
import { rowStyles } from './styles';
import clsx from 'clsx';
import { get, set, size } from 'global/lib/lodash';
import { Loading } from 'global/styles';
import { getUserAppPermissions } from 'global/utils';
import moment from 'moment';
import { getRealmIcon } from 'global/components/droprealms';

export const RowHeader = (props) => {
  const { hasClient } = props;
  const classes = rowStyles();

  return (
    <ListItem className={clsx(classes.row, classes.headerRow)}>
      <div className={classes.checkbox}>
        <Checkbox indeterminate={props.indeterminate} onClick={props.selectAll} checked={props.allSelected} />
      </div>
      {hasClient ? (
        <>
          <div className={classes.item33}>{'Name'}</div>
          <div className={classes.item33}>{'Email'}</div>
          <div className={classes.item33}>{'Access'}</div>
        </>
      ) : (
        <>
          <div className={classes.name}>
            <div className={classes.itemSm}>{'Name'}</div>
            <div className={clsx(classes.itemLg, classes.xsHide)}>{'Email'}</div>
          </div>
          <div className={classes.access}>
            <div className={classes.itemSm}>{'Access'}</div>
            <div className={clsx(classes.itemLg, classes.xsHide)}>{'Permissions'}</div>
          </div>
          <div className={classes.status}>
            <div className={classes.itemMd}>{'Status'}</div>
            <div className={clsx(classes.itemMd, classes.xsHide)}>{'Modified'}</div>
          </div>
        </>
      )}
    </ListItem>
  );
};

export default (props) => {
  const classes = rowStyles();
  const { item, index, selected, hasClient, basicDisplay } = props;

  const getAccess = () => {
    const obj = {};
    (item.realms || [])
      .filter((r) => r)
      .forEach((r) => {
        set(obj, r.tier, [...get(obj, r.tier, []), r]);
      });
    const pluralize = size(obj.community) > 1;
    const plurBuilders = size(obj.builders) > 1;
    const plurDivision = size(obj.division) > 1;
    return (
      <>
        {!!size(obj.builder) && (
          <div className={classes.flexRow}>
            {getRealmIcon({ tier: 'builder' }, classes.accessIcon)}
            <span className={classes.xsHide}>{`${size(obj.builder)} ${plurBuilders ? 'Builders' : 'Builder'}`}</span>
          </div>
        )}
        {!!size(obj.division) && (
          <div className={classes.flexRow}>
            {getRealmIcon({ tier: 'division' }, classes.accessIcon)}
            <span className={classes.xsHide}>{`${size(obj.division)} ${plurDivision ? 'Divisions' : 'Division'}`}</span>
          </div>
        )}
        {!!size(obj.community) && (
          <div className={classes.flexRow}>
            {getRealmIcon({ tier: 'community' }, classes.accessIcon)}
            <span className={classes.xsHide}>{`${size(obj.community)} ${pluralize ? 'Communities' : 'Community'}`}</span>
          </div>
        )}
      </>
    );
  };

  const getPermission = () => {
    const dp = getUserAppPermissions(item.permissions);
    return dp ? dp.map((d) => d.title).join(', ') : 'None';
  };

  const getStatus = () => {
    return get(item, 'status') === 1 ? 'Active' : 'De-Activated';
  };

  const getLastAccess = () => {
    return get(item, 'updatedAt') ? moment(get(item, 'updatedAt')).fromNow() : Loading;
  };

  const isSelected = () => {
    return get(selected, item.id) ? true : false;
  };

  const content = {
    name: get(item, 'name', Loading),
    email: get(item, 'email', Loading),
    access: getAccess(),
    permission: getPermission(),
    status: getStatus(),
    lastAccess: getLastAccess(),
  };

  const onSelectItem = (e) => {
    e.stopPropagation();
    e.preventDefault();
    props.onSelectItem && props.onSelectItem(props);
  };

  const onSelectRow = (e) => {
    props.onSelectRow && props.onSelectRow(props);
  };

  const showbg = index % 2;

  return (
    <ListItem onClick={onSelectRow} className={clsx(classes.row, classes.listRow, showbg && classes.rowBg)}>
      <div className={classes.checkbox}>
        <Checkbox onClick={onSelectItem} checked={isSelected()} />
      </div>
      {hasClient ? (
        <>
          <div className={clsx(classes.item33, basicDisplay && classes.item50)}>{content.name}</div>
          <div className={clsx(classes.item33, basicDisplay && classes.item50)}>{content.email}</div>
          {!basicDisplay && <div className={classes.item33}>{content.access}</div>}
        </>
      ) : (
        <>
          <div className={classes.name}>
            <div className={classes.itemSm}>{content.name}</div>
            <div className={classes.itemLg}>{content.email}</div>
          </div>
          <div className={classes.access}>
            <div className={classes.itemSm}>{content.access}</div>
            <div className={classes.itemLg}>{content.permission}</div>
          </div>
          <div className={classes.status}>
            <div className={classes.itemMd}>{content.status}</div>
            <div className={classes.itemMd}>{content.lastAccess}</div>
          </div>
        </>
      )}
    </ListItem>
  );
};
